<template>
  <div class="virtual-wardrobe">

    <div v-if="!loading" class="filter-wrapper mb-4">
      <div class="row">
        <div class="col-12 col-lg-2 d-flex align-items-center justify-content-lg-end">
          <label for="item_type" class="mr-2 m-lg-0">Item Type</label>
        </div>
        <div class="col-12 col-lg-3 mb-4 mb-lg-0">
          <div class="styled-dropdown">
            <select v-model="selectedItemType" name="item_type" id="item_type">
              <option :value="null">Any</option>
              <option v-for="itemType in itemTypes" :value="itemType.id" :key="itemType.id">{{ itemType.name }}</option>
            </select>
            <i class="fas fa-chevron-down"></i>
          </div>
        </div>
        <div class="col-12 col-lg-2 d-flex align-items-center justify-content-lg-end">
          <label for="school" class="mr-2 m-lg-0">School</label>
        </div>
        <div class="col-12 col-lg-3 mb-4 mb-lg-0">
          <div class="styled-dropdown">
            <select v-model="selectedSchool" name="school" id="school">
              <option :value="null">Any</option>
              <option v-for="school in schools" :value="school.id" :key="school.id">{{ school.name }}</option>
            </select>
            <i class="fas fa-chevron-down"></i>
          </div>
        </div>
        <div class="col-12 col-lg-2">
          <button type="submit" @click="getProducts()" class="btn btn-tertiary gold">Search</button>
        </div>
      </div>
    </div>

    <div v-if="!loading && products" class="row">
      <div v-for="product in products.data" :key="product.id" class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="card product-card virtual-wardrobe-card mb-4">
          <div class="card-body text-center position-relative">
            <img :src="product.primary_small_image_url" :alt="product.sku">
            <h4>ITEM CODE: {{ product.sku }}</h4>
            <div class="hover position-absolute">
              <div class="d-flex justify-content-center align-items-center flex-column h-100 p-4 p-sm-5">
                <button type="button" class="btn btn-secondary" data-toggle="modal" data-target="#imageModal" @click="selectProduct(product)">
                  Enlarge Image
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <pagination :data="products" @pagination-change-page="getProducts" :limit="5" align="center"></pagination>
      </div>
    </div>

    <div v-if="loading" class="d-flex justify-content-center align-items-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="modal fade" tabindex="-1" role="dialog" id="imageModal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">ITEM CODE: {{ selectedItemCode }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <img :src="selectedItemImage"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      itemTypes: null,
      schools: null,
      products: null,

      selectedItemType: null,
      selectedSchool: null,
      selectedItemCode: null,
      selectedItemImage: null
    };
  },

  props: [
    //
  ],

  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.selectedItemType = urlParams.get('item_type')
    this.selectedSchool = urlParams.get('school');

    this.getProducts(urlParams.get('page') || 1);
  },

  methods: {
    selectProduct(product) {
      this.selectedItemCode = product.sku;
      this.selectedItemImage = product.primary_medium_image_url;
    },
    getProducts(page = 1) {
      this.insertParams(page);

      axios.post('/api/v1/virtual-wardrobe/products', {
          'item_type': this.selectedItemType,
          'school': this.selectedSchool,
          'page': page,
        })
        .then(res => {
          if (res && res.data.success) {
            this.products = res.data.products;
            this.schools = res.data.schools;
            this.itemTypes = res.data.itemTypes;
          }
        })
        .catch(err => {
          //
        })
        .finally(() => {
          this.loading = false;
        });
    },

    insertParams(page) {
      let refresh = window.location.protocol + "//" + window.location.host + window.location.pathname;

      if (this.selectedItemType) {
        refresh += '?item_type=' + this.selectedItemType;
      }

      if (this.selectedSchool) {
        refresh += this.selectedItemType ? '&' : '?';
        refresh += 'school=' + this.selectedSchool;
      }

      if (page && page > 1) {
        refresh += this.selectedItemType || this.selectedSchool ? '&' : '?';
        refresh += 'page=' + page;
      }

      window.history.pushState({ path: refresh }, '', refresh);
    },
  },
};
</script>
